<script setup lang="ts">
import ButtonElement from './base/ButtonElement.vue'
defineProps<{ disabled: boolean }>()
defineEmits(['click'])
</script>

<template>
  <ButtonElement template="save" variant="primary" :disabled="disabled" @click="$emit('click')" />
</template>
